export default "__VITE_ASSET__CBvq$3L___"